import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Brain } from 'lucide-react';
import { AnimatedBackground } from './AnimatedBackground';

export function HeroSection() {
  return (
    <div
      className="relative min-h-screen flex items-center justify-center py-20 px-4 overflow-hidden"
      style={{
        backgroundImage: `url('https://storage.googleapis.com/msgsndr/YUjCMLfw9uWPl9jO95FS/media/688a0b05b1756e43fd78c91d.jpeg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <AnimatedBackground />

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          <Brain
            className="w-16 h-16 text-white mx-auto mb-6"
            style={{
              filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.8))',
            }}
          />
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-2 whitespace-nowrap">
            <span className="text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]">
              Discover your true potential.
            </span>
          </h1>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-8">
            <span className="text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]">
              Personality Breakthrough Profile
            </span>
          </h2>
          <p className="text-xl text-gray-700 mb-8 leading-relaxed max-w-3xl mx-auto">
            <span className="text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.6)]">
              Unlock a deeper understanding of yourself and take control of your
              personal and professional growth. Our breakthrough assessment is
              designed for life coaches, personal development seekers, and
              anyone striving for excellence.
            </span>
          </p>
          <div className="flex gap-4 justify-center">
            <Link
              to="/register"
              className="px-8 py-4 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-medium 
                hover:scale-105 transition-all"
            >
              Start Your Assessment
            </Link>
            <a
              href="#foundations"
              className="px-8 py-4 rounded-xl bg-white/90 hover:bg-white text-gray-700 font-medium transition-all
                border border-gray-200 backdrop-blur-sm"
            >
              Learn More
            </a>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
